var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.067,
    height: 55.593,
    viewBox: "0 0 60.067 55.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-624.85 -307.781)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(625 307.931)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.656,81.3,428.3,98.577l4.348-10.187Z",
    transform: "translate(-394.833 -81.287)",
    fill: "#e17726",
    stroke: "#e17726",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,81.3l23.141,17.441L205.908,88.4Z",
    transform: "translate(-183.943 -81.287)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.618,398.2l-6.218,9.491,13.308,3.665,3.817-12.942Z",
    transform: "translate(-455.2 -358.136)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.4,398.415l3.792,12.942,13.283-3.665-6.193-9.492Z",
    transform: "translate(-166.907 -358.136)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,216.1l-3.69,5.574,13.169.594-.442-14.168Z",
    transform: "translate(-254.443 -192.062)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.766,215.052,428.6,206.9l-.3,14.332,13.169-.594Z",
    transform: "translate(-394.833 -191.014)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,409.788l7.962-3.842L303.5,400.6Z",
    transform: "translate(-284.845 -360.233)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5,405.946l7.95,3.842-1.087-9.188Z",
    transform: "translate(-400.25 -360.233)",
    fill: "#e27625",
    stroke: "#e27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.45,446.742,434.5,442.9l.645,5.156-.063,2.186Z",
    transform: "translate(-400.25 -397.187)",
    fill: "#d5bfb2",
    stroke: "#d5bfb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,446.742l7.393,3.5-.051-2.186.619-5.156Z",
    transform: "translate(-284.845 -397.187)",
    fill: "#d5bfb2",
    stroke: "#d5bfb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.31,345.382l-6.61-1.934,4.664-2.149Z",
    transform: "translate(-291.223 -308.428)",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,345.382l1.946-4.082,4.689,2.149Z",
    transform: "translate(-403.308 -308.428)",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.593,407.691l1.15-9.492-7.343.2Z",
    transform: "translate(-242.038 -358.136)",
    fill: "#cc6228",
    stroke: "#cc6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.4,398.2l1.137,9.491,6.218-9.289Z",
    transform: "translate(-447.338 -358.136)",
    fill: "#cc6228",
    stroke: "#cc6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.469,315.5l-13.169.594,1.226,6.749,1.946-4.082,4.689,2.149Z",
    transform: "translate(-394.833 -285.888)",
    fill: "#cc6228",
    stroke: "#cc6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.833,320.909l4.664-2.149,1.946,4.082,1.226-6.749L267.5,315.5Z",
    transform: "translate(-254.356 -285.888)",
    fill: "#cc6228",
    stroke: "#cc6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.5,315.5l5.523,10.755-.19-5.346Z",
    transform: "translate(-254.356 -285.888)",
    fill: "#e27525",
    stroke: "#e27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.1,320.909l-.2,5.346,5.523-10.755Z",
    transform: "translate(-447.775 -285.888)",
    fill: "#e27525",
    stroke: "#e27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.226,320.2,362,326.949l1.542,7.975.341-10.5Z",
    transform: "translate(-336.913 -289.994)",
    fill: "#e27525",
    stroke: "#e27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.845,320.2l-.645,4.2.329,10.528,1.542-7.975Z",
    transform: "translate(-390.378 -289.994)",
    fill: "#e27525",
    stroke: "#e27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.342,360.234l-1.542,7.975,1.112.784,6.863-5.346.2-5.346Z",
    transform: "translate(-392.65 -323.279)",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.7,358.3l.19,5.346,6.863,5.346,1.112-.784-1.555-7.975Z",
    transform: "translate(-291.223 -323.279)",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.589,476.8l.063-2.186-.607-.506h-8.822l-.581.506.051,2.186-7.393-3.5,2.591,2.123,5.245,3.615h8.986l5.27-3.615,2.566-2.123Z",
    transform: "translate(-284.758 -423.745)",
    fill: "#c0ac9d",
    stroke: "#c0ac9d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.852,437.484l-1.112-.784h-6.509l-1.112.784-.619,5.156.581-.506H369.9l.607.506Z",
    transform: "translate(-335.602 -391.771)",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.058,99.614l1.959-9.542L457.06,81.2,434.5,97.908l8.683,7.33,12.259,3.577,2.7-3.16-1.175-.847,1.87-1.706-1.428-1.1,1.87-1.428Z",
    transform: "translate(-400.25 -81.2)",
    fill: "#763e1a",
    stroke: "#763e1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.5,90.172l1.984,9.542-1.276.948,1.9,1.428-1.428,1.1,1.87,1.706-1.175.847,2.7,3.16,12.259-3.577L189.017,98l-22.56-16.7Z",
    transform: "translate(-163.5 -81.287)",
    fill: "#763e1a",
    stroke: "#763e1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.892,274.877,490.633,271.3l3.69,5.574L488.8,287.629l7.292-.089H507Z",
    transform: "translate(-447.687 -247.274)",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.841,271.4l-12.259,3.577L167.5,287.64h10.882l7.292.088-5.523-10.755Z",
    transform: "translate(-166.994 -247.362)",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,160.5l.784-13.5,3.551-9.605H337.3l3.551,9.605.784,13.5.3,4.234.025,10.477h6.509l.025-10.477Z",
    transform: "translate(-315.334 -130.297)",
    fill: "#f5841f",
    stroke: "#f5841f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.f00cfe4127a5654a4023bcec9e6d4d2e.svg";
export { ForwardRef as ReactComponent };